import CryptoJS from 'crypto-js';
import * as ConfigJSON from '../configs/server.configs';
import { authorization, webConfig } from '../configs/system.configs';
import * as Utils from '../utils/Utils';
import BaseServices from './baseServices';
import accountServices from './accountServices';
import userServices from './userServices';

const config = ConfigJSON[process.env.NODE_ENV];

// Backup key for the real admin session while "logging in as" another user for testing.
const IMPERSONATOR_KEY = '_impersonator';

export default {
  logout: async () => {
    const _user = Utils.getUserLogin();
    if (_user?.AccessToken) {
      const response = await accountServices.logout({ token: _user.AccessToken });
    }
    localStorage.removeItem(authorization);
    localStorage.removeItem('_user');
    localStorage.removeItem(IMPERSONATOR_KEY);
    window.location.href = webConfig.logoutUrl;
  },
  // whether the current session is an admin "logging in as" another user
  isLoggingAs: () => {
    return !!localStorage.getItem(IMPERSONATOR_KEY);
  },
  // fetch another user's login data and switch the current session to use their access token
  loginAs: async (userId) => {
    try {
      const response = await userServices.getLoginUserData(userId);
      if (!response.success) {
        return { isSuccess: false, message: response.message };
      }
      const currentUserRaw = localStorage.getItem('_user');
      if (currentUserRaw && !localStorage.getItem(IMPERSONATOR_KEY)) {
        localStorage.setItem(IMPERSONATOR_KEY, currentUserRaw);
      }
      const targetUser = { ...response.data };
      const roleId = JSON.stringify(targetUser.RoleId);
      targetUser.RoleId = CryptoJS.AES.encrypt(roleId, config.tokenSecret).toString();
      localStorage.setItem('_user', JSON.stringify(targetUser));
      return { isSuccess: true };
    } catch (error) {
      return { isSuccess: false, message: error?.message };
    }
  },
  // exit "logging in as" and restore the original admin session, without hitting the real logout endpoint
  logoutLoginAs: () => {
    const originUserRaw = localStorage.getItem(IMPERSONATOR_KEY);
    if (originUserRaw) {
      localStorage.setItem('_user', originUserRaw);
      localStorage.removeItem(IMPERSONATOR_KEY);
    }
    window.location.href = '/';
  },
  getAuthenticateToken: () => {
    try {
      const _user = Utils.getUserLogin();
      // for webview app
      if (!_user) {
        const tokenEncrypt = localStorage.getItem(authorization);
        if (!tokenEncrypt) {
          return null;
        }
        return CryptoJS.AES.decrypt(tokenEncrypt.toString(), config.tokenSecret).toString(CryptoJS.enc.Utf8);
      }
      return _user?.AccessToken;
    } catch (error) {}
  },
  getBankToken: () => {
    return 'Oryton_BankService_1234!@';
  },
  getPsd2Token: () => {
    return 'Oryton_PSD2_1234!@';
  },
  getEHFToken: () => {
    return 'Oryton_EHF_J9qE%h';
  },
  getAuthenticate: () => {
    try {
      const tokenEncrypt = localStorage.getItem(authorization);
      if (tokenEncrypt === null || tokenEncrypt === undefined) {
        return null;
      }
      const bytes = CryptoJS.AES.decrypt(tokenEncrypt.toString(), config.tokenSecret);
      const token = bytes.toString(CryptoJS.enc.Utf8);
      return token;
    } catch (e) {
      return null;
    }
  },
  refreshToken: async (refreshToken) => {
    try {
      const url = webConfig.refreshToken;
      const data = await BaseServices.postData({
        url,
        data: { refreshToken },
      });
      return await data.json();
    } catch (error) {
      return { isSuccess: false, message: error.message };
    }
  },
};
